import { colors, fonts } from '@grupoboticario/flora-tokens/dist/fidelidadeQuemDisseBerenice/web/ds'

export const fidelidadeQuemDisseBerenice = {
  colors,
  fonts,
}
